/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
import DepartmentMemberSelector from './DepartmentMemberSelector';
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export type {
  DepartmentMemberDepartment,
  DepartmentMemberEmployee,
  DepartmentMemberSelectionItem,
  DepartmentMemberSelectionMode,
  DepartmentMemberSelectionType,
  DepartmentMemberSelectorProps,
} from './DepartmentMemberSelector';

export {
  AvatarDropdown,
  AvatarName,
  DepartmentMemberSelector,
  Footer,
  Question,
  SelectLang,
};
